import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  trips: [],
  drivers: [],
  vehicles: [],
  tripRequests: [],
  loading: false,
};

const ouberSlice = createSlice({
  name: "ouberSlice",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTrips: (state, action) => {
      state.trips = action.payload;
    },
    setDrivers: (state, action) => {
      state.drivers = action.payload;
    },
    setVehicles: (state, action) => {
      state.vehicles = action.payload;
    },
    setTripRequests: (state, action) => {
      state.tripRequests = action.payload;
    },
  },
});

export const {
  setLoading,
  setTrips,
  setDrivers,
  setVehicles,
  setTripRequests,
} = ouberSlice.actions;

export default ouberSlice.reducer;
